import React, { useEffect } from 'react';

export default function EirCustomiseBundleIncludes(props) {
    const { setCustmiseCheckoutActiveStep } = props
    useEffect(() => {
        setTimeout(() => {
            // console.log("includes js useeffect");
            const cartStyle = document.createElement("link");
            cartStyle.href = "/opencms/export/system/modules/net.eir.opencms/resources/css/global.min.css?v=2";

            const checkoutScript = document.createElement("script");
            checkoutScript.src = "/system/modules/net.eir.opencms/resources/js/external/modules/application-page/ap-checkout.js";
            checkoutScript.async = true;

            const cartScript = document.createElement("script");
            cartScript.src = "/system/modules/net.eir.opencms/resources/js/external/modules/application-page/ap-cart.js";
            cartScript.async = true;

            const layoutScript = document.createElement("script");
            layoutScript.src = "/system/modules/net.eir.opencms/resources/js/external/modules/application-page/ap-layout.js";
            layoutScript.async = true;

            const configScript = document.createElement("script");
            configScript.src = "/system/modules/net.eir.opencms/resources/js/external/modules/application-page/ap-config.js";
            configScript.async = true;

            document.getElementsByTagName("head")[0].appendChild(layoutScript);
            document.getElementsByTagName("head")[0].appendChild(cartStyle);
            document.getElementsByTagName("head")[0].appendChild(configScript);
            document.getElementsByTagName("head")[0].appendChild(checkoutScript);
            document.getElementsByTagName("head")[0].appendChild(cartScript);

            return () => {
                document.getElementsByTagName("head")[0].removeChild(cartStyle);
                document.getElementsByTagName("head")[0].removeChild(configScript);
                document.getElementsByTagName("head")[0].removeChild(checkoutScript);
                document.getElementsByTagName("head")[0].removeChild(cartScript);
                document.getElementsByTagName("head")[0].removeChild(layoutScript);
            }
        }, 4000);
    }, []);
    return (
        <div className="d-none">Includes
        </div>
    );
}
